import { render, staticRenderFns } from "./LessonWordSeoEn.vue?vue&type=template&id=554f11bf&"
import script from "./LessonWordSeoEn.vue?vue&type=script&lang=js&"
export * from "./LessonWordSeoEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports